// extracted by css-extract-rspack-plugin
export default {"menuButton":"menuButton-rtmTAt","slim":"slim-GpCgrl"};